(() => {
  if (customElements.get('cro-section-navigation')) return;
  class SectionNavigation extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.section = this.closest('.section-navigation-links');
      this.header = document.querySelector('cro-header, theme-header');
      const targets = [...document.querySelectorAll('[data-nav]')];
      this.links = [...this.querySelectorAll('a[data-section]')].map(link => {
        const target = targets.find(target => target.dataset.nav === link.dataset.section);
        link.hidden = !target;
        if (target) {
          if (!target.id) target.id = 'product-detail-' + encodeURIComponent(link.dataset.section);
          link.setAttribute('href', '#' + target.id);
          link.addEventListener('click', event => {
            event.preventDefault();
            this.pendingTarget = target;
            this.followUntil = Date.now() + 5000;
            this.update();
            window.scrollTo({
              top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - this.offset),
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
            });
            clearTimeout(this.settleTimer);
            this.settleTimer = setTimeout(() => this.correctDestination(), 900);
          }, {signal});
        }
        return {link, target};
      }).filter(item => item.target);
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      window.addEventListener('scroll', this.schedule, {signal, passive:true});
      window.addEventListener('resize', this.schedule, {signal});
      // Reviews can expand after a jump; keep its destination below the sticky bars.
      const cancelFollow = () => {this.pendingTarget = null;};
      ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => window.addEventListener(type, cancelFollow, {signal, passive:true}));
      if (window.ResizeObserver) {
        this.observer = new ResizeObserver(() => {
          this.update();
          this.correctDestination();
          // Let browser scroll anchoring finish before the final alignment.
          clearTimeout(this.layoutTimer);
          this.layoutTimer = setTimeout(() => this.correctDestination(), 100);
        });
        this.observer.observe(document.body);
        this.observer.observe(this);
        if (this.header) this.observer.observe(this.header);
      }
      this.update();
    }
    correctDestination() {
      if (!this.pendingTarget || Date.now() >= this.followUntil) return;
      this.update();
      const delta = this.pendingTarget.getBoundingClientRect().top - this.offset;
      if (Math.abs(delta) > 2) window.scrollTo({top:Math.max(0, window.scrollY + delta), behavior:'instant'});
    }
    update() {
      const headerBottom = Math.max(0, this.header?.getBoundingClientRect().bottom || 0);
      if (this.section) this.section.style.top = headerBottom + 'px';
      this.offset = headerBottom + this.getBoundingClientRect().height + 12;
      let current = this.links[0];
      this.links.forEach(item => {
        if (item.target.getBoundingClientRect().top <= this.offset + 8) current = item;
      });
      this.links.forEach(item => {
        item.link.classList.toggle('active-nav', item === current);
        if (item === current) item.link.setAttribute('aria-current', 'location');
        else item.link.removeAttribute('aria-current');
      });
    }
    disconnectedCallback() {
      this.pendingTarget = null;
      clearTimeout(this.settleTimer);
      clearTimeout(this.layoutTimer);
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  }
  customElements.define('cro-section-navigation', SectionNavigation);
})();
